import styled from "styled-components";


export const Container = styled.main`
    width: 100vw;
    height: 90vh;
    margin: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: transparent;
`


export const InfoContainer = styled.div`
    margin:30px ;
    height: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
`

export const Text = styled.p`
    font-size: 1.02rem;
    margin:2px ;
`

